module.exports = __webpack_public_path__ + "media/images/countryrect/er-bcc72c68e3f9e5c4538c421588884d01.svg";